import React from "react";
import { styled, Paper } from "@mui/material";

const FiltersContainers = styled(({ children, ...props }) => (
  <Paper {...props} elevation={1} square>
    {children}
  </Paper>
))(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  height: "60px",
  borderBottom: "1px solid #E7E9EF",
  marginTop: "104px",
  background: "#fff",
}));

const FiltersHeader = () => {
  return <FiltersContainers></FiltersContainers>;
};

export default FiltersHeader;
